export default {
    props: {
        messagesChecked: {
            type: String,
            default: undefined,
            kComposite: 'messages.checked'
        }, 
        messagesUnchecked: {
            type: String,
            default: undefined,
            kComposite: 'messages.unchecked'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/Messages.js